import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";

import { Button } from "../../components/Button";

export function WorkedBreaksLearnMoreButton() {
  const { openArticle } = useZendeskArticle();
  const { breakPaymentRequestsSupportLink } = useSupportLinks();
  return (
    <Button
      fullWidth
      variant="outlined"
      onClick={async () => {
        await openArticle(breakPaymentRequestsSupportLink);
      }}
    >
      Learn more
    </Button>
  );
}
